import { createSelector } from 'reselect';

import { formatParameterFileList } from './helpers';
import { getSelectedNotification } from '../../../../PowertrainOverview/Header/NotificationDropdown/selectors';


export const getChangedParameterFileListV2 = ({ changedParametersV2 }) => {
	return changedParametersV2 && {
		...changedParametersV2.getChangedParameterFileListV2,
		data: formatParameterFileList(changedParametersV2.changedParameterFileListV2.data)
	};
};

export const getSelectedDrive = ({ powertrainAssetDetails }) => {
	return powertrainAssetDetails.selectedAsset;
};

export const getChangedParametersListLoading = ({ changedParametersV2 }) => {
	return changedParametersV2 && changedParametersV2.changedParameterFileListV2 && changedParametersV2.changedParameterFileListV2.loadingStatus;
};

export const getModel = createSelector([
	getChangedParameterFileListV2,
	getSelectedDrive,
	getChangedParametersListLoading,
	getSelectedNotification
],
	(
		changedParameterFileList,
		selectedDrive,
		changedParametersListLoading,
		selectedNotification
	) => {
		return {
			changedParameterFileList,
			selectedDrive,
			changedParametersListLoading,
			selectedNotification
		};
	});
